import { combineReducers, Reducer } from 'redux';
import globalReducer from "./global"
import statusReducer from "./slices/status";
import authReducer from "./slices/auth";
import globalProductReducer from "./slices/globalProduct";
import globalCategoryReducer from "./slices/globalCategory";
import globalBrandReducer from "./slices/globalBrand";
import globalSupplierReducer from "./slices/globalSupplier";
import  globalVariant from './slices/globalVariant';
import customer from "./slices/customer";
import user from "./slices/user"
import store from "./slices/store"
import invoice from "./slices/invoice"
import tenant from "./slices/tenantSlice";
import { baseApi } from "./services/baseApi";


import initialState from "./initial.value";

const appReducer = combineReducers({
  status: statusReducer,
  global: globalReducer,
  auth: authReducer,
  globalProduct: globalProductReducer,
  globalCategory: globalCategoryReducer,
  globalBrand: globalBrandReducer,
  globalSupplier: globalSupplierReducer,
  customer: customer,
  user: user,
  store: store,
  globalVariant: globalVariant,
  invoice: invoice,
  tenant: tenant,
  // RTK Query cache (new integrations). Not persisted — see persist blacklist.
  [baseApi.reducerPath]: baseApi.reducer,
});

/**
 * Dispatched on sign-out. Every slice drops back to its initial state.
 *
 * `persistor.purge()` alone was not enough: it deletes the persisted blob, but
 * the running store still holds the previous account's data and redux-persist
 * immediately writes it straight back. After a logout the globalProduct slice
 * was observed still carrying the last user's catalogue. Resetting at the root
 * is the only place that reaches every slice, including ones added later.
 */
export const RESET_STATE = "app/reset";

const rootReducer: Reducer = (state: any, action: any) => {
  if (action?.type === RESET_STATE) {
    // Undefined state makes every child reducer return its own initial value.
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
